const ERROR_MESSAGES: { [key: string]: string } = {
  system_error: 'System error occurred, please try again later',

  /* Upload knowledge */
  outOfFileSizeLimit: 'Out of range file size limit ',
  outOfTotalSizeLimit: 'Out of range total size limit',
  outOfNumberOfFile: 'Out of range number of file limit',
  outOfCreateLimit: 'Out of range number create limit',
  filenameExisted: 'This file has already been uploaded.',
  /* Chat */
  outOfNumberOfSession: 'Out of range session limit',
  permissionDenied: 'Not allowed to upload files while chatting.',

  /* add knowledge */
  integer: 'The total size must be an integer.',
  alreadyExists: 'File has been existed',
  extensionInvalid: 'File extension invalid',
  isFolder: 'File extension invalid',

  /* Slack */
  slackUsed: 'This Slack workspace is already connected to another agent',

  /* instagram */
  instagramUsed: 'This Instagram is already connected to another agent',
  instagramNotFound:
    'Your Instagram account is not linked to your Facebook Page. Please link them to enable the chatbot',

  /* facebook */
  fanPageUsed: 'This Fanpage is already connected to another agent',

  /* zalo */
  oaIdUsed: 'This Zalo OA is already connected to another agent',

  verifier: 'Invalid Verifier',
  whatsappVerifier: 'This Facebook account does not have any WhatsApp Business accounts linked to it.',

  /* Whats app */
  accountNotFound: 'This Facebook account does not have any WhatsApp Business accounts linked to it.',
  whatsappUsed: 'This WhatsApp Business account is already linked to another agent.',

  /* Zalo Bot */
  botTokenInvalid: 'Bot token is invalid.',
  uniqueBotZalo: 'This Zalo bot is already integrated with another agent. Please use a different bot and try again.',

  /* AI action */
  uniqueName: 'Action name already exists',
  uniqueAction: 'Command already exists',

  /* Billing */
  noPaymentCard: 'Please add a payment method to proceed with renewal',

  /* Integration */
  failVerifyWebhookUrl: 'Cannot reach the webhook endpoint. Please try again',
  unique: 'This webhook already exists.',

  /* Provider */
  unique3: 'Save failed. Configuration with the same name already exists',
  unique2: 'Save failed. Configuration with the same name or key already exists',

  uniqueEmailTemplate: 'Template name already exists',

  // billing
  cancelPayment: 'Payment failed. Please try again or use a different payment method.',

  // General error
  packageFreeTrialInvalid: 'Something went wrong, please try again later',
  requiredIf: 'Please select at least one data tag.',
  linkExisted: 'This website/sitemap has already been crawled.'
};

export const DEFAULT_ERROR = ERROR_MESSAGES.system_error;
export default ERROR_MESSAGES;
